// Vendors
import React from 'react';
// Components
import { ErrorAccordionComponent } from 'components/error-accordion/error-accordion.component';
import { ErrorComponent } from 'components/error/error.component';
// Contexts
import { LayoutContextProvider } from 'components/layout/contexts/layout.context';
// Constants
import { ENTRYPOINT_ORCHESTRATOR_UNCATEGORIZED_COMPONENT_PROPS } from './constants/entrypoint-orchestrator-uncategorized.constants';
// Hooks
import { useEntrypointOrchestratorUncategorizedHook } from './hooks/entrypoint-orchestrator-uncategorized.hook';
// Styles
import { EntrypointOrchestratorUncategorizedStyled } from './entrypoint-orchestrator-uncategorized.component.styled';
import { HeaderLayoutContentFullHeightStyled } from 'styles/app.styled';
// Translations
import { ORDER_STATUS } from './translations/entrypoint-orchestrator-uncategorized.translations';

const EntrypointOrchestratorUncategorizedComponent = (): React.JSX.Element => {
  const { currentState, formatMessage } = useEntrypointOrchestratorUncategorizedHook();

  return (
    <LayoutContextProvider>
      <HeaderLayoutContentFullHeightStyled>
        <EntrypointOrchestratorUncategorizedStyled>
          <ErrorComponent {...ENTRYPOINT_ORCHESTRATOR_UNCATEGORIZED_COMPONENT_PROPS} />
          <ErrorAccordionComponent
            {...{
              error: currentState,
              description: formatMessage({ id: ORDER_STATUS }, { currentState }),
            }}
          />
        </EntrypointOrchestratorUncategorizedStyled>
      </HeaderLayoutContentFullHeightStyled>
    </LayoutContextProvider>
  );
};

export { EntrypointOrchestratorUncategorizedComponent };
